/**
 * @hidden
 */
export var EXPAND_FIELD = 'expanded';
/**
 * @hidden
 */
export var SELECT_FIELD = 'selected';
//# sourceMappingURL=consts.js.map